var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"faq",attrs:{"id":"faq"}},[_c('h2',{staticClass:"title"},[_vm._v(" 자주하는 질문 ")]),_c('VueFaqAccordion',{attrs:{"items":_vm.faq}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }